var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "summarize-timeline-item" }, [
    _c("span", { staticClass: "summarize-timeline-item-icon | filled-icon" }, [
      _c(
        "svg",
        {
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
          },
        },
        [
          _c("path", { attrs: { fill: "none", d: "M0 0h24v24H0z" } }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              fill: "currentColor",
              d: "M6.455 19L2 22.5V4a1 1 0 0 1 1-1h18a1 1 0 0 1-1 1H6.455zM7 10v2h2v-2H7zm4 0v2h2v-2h-2zm4 0v2h2v-2h-2z",
            },
          }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "summarize-timeline-item-wrapper" }, [
      _c("div", { staticClass: "summarize-timeline-item-description" }, [
        _c("span", [
          _c("time", { attrs: { datetime: _vm.date } }, [
            _vm._v(_vm._s(_vm.date)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "summarize-comment" }, [
        _c("p", [_vm._v(_vm._s(_vm.content))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }